import { render, staticRenderFns } from "./NdLoadHistory.vue?vue&type=template&id=6e971474&"
import script from "./NdLoadHistory.vue?vue&type=script&lang=js&"
export * from "./NdLoadHistory.vue?vue&type=script&lang=js&"
import style0 from "./NdLoadHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports